{
  "common.actions.buscar": {
    "defaultMessage": "Search"
  },
  "common.actions.close": {
    "defaultMessage": "Close"
  },
  "common.actions.createEntity": {
    "defaultMessage": "common.actions.createEntity"
  },
  "common.actions.edit": {
    "defaultMessage": "common.actions.edit"
  },
  "common.actions.select": {
    "defaultMessage": "Select..."
  },
  "common.actions.selectAll": {
    "defaultMessage": "Select all"
  },
  "common.actions.selectNone": {
    "defaultMessage": "Select none"
  },
  "common.actions.share": {
    "defaultMessage": "Share"
  },
  "common.actions.view": {
    "defaultMessage": "View"
  },
  "common.apiError.body": {
    "defaultMessage": "Please try again in a few seconds. {br}Contact us if the error persists."
  },
  "common.apiError.title": {
    "defaultMessage": "Server is not responding"
  },
  "common.confirmationModal.cancelBtnText": {
    "defaultMessage": "Cancel"
  },
  "common.confirmationModal.confirmBtnText": {
    "defaultMessage": "Confirm"
  },
  "common.copyBtn.copied": {
    "defaultMessage": "Copied"
  },
  "common.fatalError.body": {
    "defaultMessage": "Try going back to the home page. If the problem continues, sign in again or contact us."
  },
  "common.fatalError.loginAgainBtn": {
    "defaultMessage": "Sign in"
  },
  "common.fatalError.refreshBtn": {
    "defaultMessage": "Go to home"
  },
  "common.fatalError.title": {
    "defaultMessage": "Something went wrong"
  },
  "common.fileInput.btnText": {
    "defaultMessage": "Select files"
  },
  "common.form.cancelBtnText": {
    "defaultMessage": "Cancel"
  },
  "common.form.dateRange.endDatePlaceholder": {
    "defaultMessage": "To"
  },
  "common.form.dateRange.startDatePlaceholder": {
    "defaultMessage": "From"
  },
  "common.form.errorNotification": {
    "defaultMessage": "An error occurred. {br}Please check all fields and try again"
  },
  "common.form.exitCancelBtnText": {
    "defaultMessage": "Continue editing"
  },
  "common.form.exitConfirmBtnText": {
    "defaultMessage": "Exit without saving"
  },
  "common.form.exitPrompt": {
    "defaultMessage": "Do you want to cancel? {br}Unsaved changes will be lost."
  },
  "common.form.saveBtnText": {
    "defaultMessage": "Save"
  },
  "common.form.savedBtnText": {
    "defaultMessage": "Saved"
  },
  "common.form.updateBtnText": {
    "defaultMessage": "Update"
  },
  "common.form.updatedBtnText": {
    "defaultMessage": "Updated"
  },
  "common.languageSelect.defaultLabel": {
    "defaultMessage": "Language"
  },
  "common.listFilter.apply": {
    "defaultMessage": "Search"
  },
  "common.listFilter.reset": {
    "defaultMessage": "Reset"
  },
  "common.noResults": {
    "defaultMessage": "common.noResults"
  },
  "common.pagination.countText": {
    "defaultMessage": "Showing {showCount, plural, =0 {no items} one {# item} other {# items}} of {totalCount}"
  },
  "common.reset": {
    "defaultMessage": "Reset"
  },
  "common.text.clear": {
    "defaultMessage": "Clear"
  },
  "common.timezoneSelect.defaultLabel": {
    "defaultMessage": "Timezone"
  },
  "common.viewError.actions.back": {
    "defaultMessage": "Go back"
  },
  "common.viewError.actions.home": {
    "defaultMessage": "Go to home"
  },
  "common.viewError.actions.retry": {
    "defaultMessage": "Try again"
  },
  "common.viewError.details.toggle": {
    "defaultMessage": "Technical details"
  },
  "common.viewError.error.help": {
    "defaultMessage": "Try again. If the problem persists, contact us."
  },
  "common.viewError.error.title": {
    "defaultMessage": "We couldn't load this information"
  },
  "common.viewError.forbidden.help": {
    "defaultMessage": "If you think you should have access, ask an administrator for it."
  },
  "common.viewError.forbidden.title": {
    "defaultMessage": "You don't have permission to see this"
  },
  "common.viewError.notFound.help": {
    "defaultMessage": "The item doesn't exist or was deleted. Check the link or go back to the list."
  },
  "common.viewError.notFound.title": {
    "defaultMessage": "We couldn't find what you were looking for"
  },
  "common.viewError.unavailable.help": {
    "defaultMessage": "Check your connection and try again in a few moments."
  },
  "common.viewError.unavailable.title": {
    "defaultMessage": "We couldn't connect"
  },
  "stream.thumbnails.empty": {
    "defaultMessage": "No hay miniaturas disponibles"
  },
  "stream.thumbnails.loading": {
    "defaultMessage": "Cargando miniaturas"
  },
  "common.resultsCount": {
    "defaultMessage": "{count, plural, zero {No results}one {1 result found}other {# results found}}"
  }
}
